import FormHelperText from "@mui/material/FormHelperText";

//TODO: Don't have styles for this yet, update when needed
function FormFieldHelperText({ id, text }) {
  return <FormHelperText id={id + "-hint"}>{text}</FormHelperText>;
}

export default FormFieldHelperText;
